import React, { useState } from 'react';
import { useTour } from '@reactour/tour'
import { Button, Typography } from "@mui/material";
import styles from "../styles";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

/**
 * Represents the FretboardDiagramTour component.
 * This component displays a button that triggers a tour.
 */
const FretboardDiagramTour = () => {
    const { setIsOpen } = useTour()

    return (
        <div>
            <Button onClick={() => setIsOpen(true)} variant='outlined' size='small' endIcon={<PlayArrowIcon />}>Tour</Button>
        </div>
    );
};

export default FretboardDiagramTour;
